import EthereumTransaction from '../transactions/EthereumTransaction.js';
import ipfs from 'decentralized/Ipfs.js';
import {XANADU} from '../transactions/contracts.js';
import {bytes32ToIPFSHash, ipfsHashToBytes32} from 'utils/ipfsHash.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import XanaduContract from '../contracts/XanaduContract.js';
import {
    NewAnnotationType,
    NewAnnotation,
    NewLinkType,
    NewLink,
    NewDataType
} from 'decentralized/EthereumEvents.js';


export default superclass => class extends superclass  {

    annotationContentCache = {};

    async newAnnotationType(annotationType, description) {
        await new EthereumTransaction(
            XANADU,
            'newAnnotationType',
            [this.web3.utils.fromAscii(annotationType), description])
            .execute();
    }

    async getAnnotations(annotationType, ... contentHashes) {
        let query = new BackendQuery(new XanaduContract().contractAddress)
            .from(NewAnnotation)
            .select('data')
            .select('annotationData')
            .select('address')
            .where('annotationType', annotationType)
            .whereIn('data', contentHashes);

        return await query.executeQuery();
    }

    async getContentReferences(annotationData) {
        let query = new BackendQuery(new XanaduContract().contractAddress)
            .from(NewAnnotation)
            .select("data")
            .where("annotationData", annotationData);

        let results = await query.executeQuery();
        return results.map(x => x.data);
    }

    async getFlattenedAnnotations(annotationType, ... contentHashes) {
        let results = await this.getAnnotations(annotationType, ... contentHashes);
        let dataToAnnotations = {};
        for (let result of results) {
            let {annotationData} = result;
            if (!(annotationData in dataToAnnotations)) {
                dataToAnnotations[annotationData] = [];
            }

            dataToAnnotations[annotationData].push(result);
        }

        // need the list to be somethign like
        // {annotationData, datas, user, etc}
        let annotations = [];
        for (let annotationData in dataToAnnotations) {
            let _annotations = dataToAnnotations[annotationData];
            let result = {
                annotationData,
                address: _annotations[0].address,
                contentHashes: _annotations.map(x => x.data),
                blockNumber: _annotations[0].blockNumber
            };
            annotations.push(result);
        }
        return annotations;
    }

    async getAnnotationContents(annotationType, contentHash) {
        let annotations = await this.getAnnotations(annotationType, contentHash);
        let utils = this.web3.utils;
        for (let annotation of annotations) {
            let c=undefined;
            let x = utils.fromAscii(annotation.annotationData);
            c = await ipfs.getJson(bytes32ToIPFSHash(utils.fromAscii(annotation.annotationData)));
            annotation.content = c;
        }
        return annotations;
    }

    /**
     * annotation is expected to be a string that will be directly converted
     * to bytes32 and stored on blockchain
     */
    async newAnnotation(annotationType, contentHash, annotation) {
        await new EthereumTransaction(
            XANADU,
            'newAnnotation',
            [
                this.web3.utils.fromAscii(annotationType),
                ipfsHashToBytes32(contentHash),
                this.web3.utils.fromAscii(annotation)])
            .execute();
    }

    /**
     * annotation is expected to be a string that will be pushed
     * to ipfs, with the hash stored on the blockchain
     */
    async newAnnotationContent(annotationType, contentHash, annotationContent) {
        let annotationHash = await ipfs.addJson(annotationContent);
        await this.newAnnotationHash(annotationType, contentHash, annotationHash);
    }

    async newAnnotationHash(annotationType, contentHash, annotationHash) {
        await new EthereumTransaction(
            XANADU,
            'newAnnotation',
            [
                this.web3.utils.fromAscii(annotationType),
                ipfsHashToBytes32(contentHash),
                ipfsHashToBytes32(annotationHash)])
            .execute();
    }

    async getAnnotationTypes() {
        let query = new BackendQuery(new XanaduContract().contractAddress)
            .from(NewAnnotationType)
            .select('annotationType')
            .select('description');

        return await query.executeQuery();
    }
}
